import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ProductCard } from "@/components/shop/ProductCard";
import { QuickView } from "@/components/shop/QuickView";
import { products } from "@/lib/products";
import { useWishlist } from "@/lib/store";
import { API_BASE_URL } from "@/lib/api";

export function BestSellers() {
  const { has, toggle } = useWishlist();
  const [quickId, setQuickId] = useState<string | null>(null);

  const { data: dbProducts = products } = useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/products`);
        if (res.ok) return await res.json();
      } catch (err) {
        // silent fallback
      }
      return products;
    }
  });

  const featured = dbProducts.slice(0, 4);
  const quickProduct = quickId ? dbProducts.find((p: any) => p.id === quickId) ?? null : null;

  return (
    <section id="shop" className="py-14 lg:py-24 bg-secondary/40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="text-center mb-10 lg:mb-14">
          <p className="eyebrow">Our Favorites</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl">
            Best <span className="italic text-gold">Selling</span>
          </h2>
          <div className="mx-auto mt-5 h-px w-20 bg-gold" />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 lg:gap-8">
          {featured.map((p: any) => (
            <ProductCard
              key={p.id}
              product={p}
              wishlisted={has(p.id)}
              onWishlist={() => toggle(p.id)}
              onQuickView={() => setQuickId(p.id)}
            />
          ))}
        </div>
      </div>

      <QuickView
        product={quickProduct}
        wishlisted={quickProduct ? has(quickProduct.id) : false}
        onWishlist={() => quickProduct && toggle(quickProduct.id)}
        onClose={() => setQuickId(null)}
      />
    </section>
  );
}